module.exports = __webpack_public_path__ + "img/iphone3.e878304f.png";